import { render, staticRenderFns } from "./Ourproduct.vue?vue&type=template&id=7d986f01&"
import script from "./Ourproduct.vue?vue&type=script&lang=js&"
export * from "./Ourproduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports